export enum PaymentCardTypeEnum {
    None = 0,
    Mastercard = 1,
    Visa = 2
}
